import React from 'react';
import { useSelector } from 'react-redux';

import SleepImage from '../../assets/images/death_reasons/sleepImage';
import SleepEng from '../../assets/images/death_reasons/sleepEng';
import SleepRus from '../../assets/images/death_reasons/sleepRus';
import Border from '../../assets/images/border';

import './sleep.scss';

const Sleep = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='sleep'>
            <Border />
            {language === 'ENG' ? <SleepEng /> : <SleepRus />}
            <SleepImage />
            <span className='sleep-text'>
                {language === 'RUS' ? 'Постоянные проблемы со сном при высоком риске могут привести к систематическому истощению организма, увеличивая вероятность различных заболеваний и заметно снижая ожидаемую продолжительность жизни.' : 'Persistent sleep problems at high risk can lead to systematic depletion of the body, increasing the risk of various diseases and significantly reducing life expectancy.'}
            </span>
        </div>
    );
};

export default Sleep;